const Services = () => {
  const services = [
    {
      icon: 'ri-building-line',
      title: 'Rural Real Estate Development',
      description: 'Strategic development of rural properties with focus on sustainable growth and community integration.',
      features: ['Land acquisition', 'Development planning', 'Infrastructure design', 'Community engagement']
    },
    {
      icon: 'ri-plant-line',
      title: 'Agricultural Investment',
      description: 'Comprehensive agricultural investment opportunities from crop production to agro-processing facilities.',
      features: ['Crop investment', 'Livestock projects', 'Agro-processing', 'Supply chain development']
    },
    {
      icon: 'ri-government-line',
      title: 'Government Partnerships',
      description: 'Facilitating strategic partnerships between private investors and government entities for large-scale projects.',
      features: ['Policy navigation', 'Regulatory compliance', 'Public-private partnerships', 'Grant facilitation']
    },
    {
      icon: 'ri-store-line',
      title: 'Rural Commerce Development',
      description: 'Developing modern retail infrastructure to replace traditional spaza shops with full-service grocery stores.',
      features: ['Retail planning', 'Supply chain setup', 'Local employment', 'Community services']
    },
    {
      icon: 'ri-road-map-line',
      title: 'Infrastructure Investment',
      description: 'Critical infrastructure projects that unlock rural potential and create sustainable economic growth.',
      features: ['Transportation networks', 'Utilities development', 'Digital infrastructure', 'Healthcare facilities']
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Investment Research',
      description: 'Comprehensive market research and feasibility studies for informed investment decisions.',
      features: ['Market analysis', 'Risk assessment', 'ROI projections', 'Regulatory guidance']
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Comprehensive Rural Investment Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From initial research to project completion, we provide end-to-end services that ensure successful rural investment outcomes.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-emerald-100 rounded-xl flex items-center justify-center mb-6">
                <i className={`${service.icon} text-emerald-600 text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-emerald-600 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="bg-emerald-600 text-white px-8 py-4 rounded-lg hover:bg-emerald-700 transition-colors duration-200 font-semibold whitespace-nowrap cursor-pointer">
            Discuss Your Project
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;